/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ListInvitationsQueryResponse, ListInvitationsPathParams, ListInvitationsQueryParams, ListInvitations400, ListInvitations401, ListInvitations403, ListInvitations404, ListInvitations409, ListInvitations500 } from "../../types/staffController/ListInvitations.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { listInvitations } from "../../client/staffController/listInvitations.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const listInvitationsQueryKey = (organizationId: ListInvitationsPathParams["organizationId"] | undefined, params?: ListInvitationsQueryParams) => [{ url: '/api/organizations/:organizationId/invitations', params: {organizationId:organizationId} }, ...(params ? [params] : [])] as const

export type ListInvitationsQueryKey = ReturnType<typeof listInvitationsQueryKey>

export function listInvitationsQueryOptions(organizationId: ListInvitationsPathParams["organizationId"] | undefined, params?: ListInvitationsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = listInvitationsQueryKey(organizationId, params)
        return queryOptions<ListInvitationsQueryResponse, ResponseErrorConfig<ListInvitations400 | ListInvitations401 | ListInvitations403 | ListInvitations404 | ListInvitations409 | ListInvitations500>, ListInvitationsQueryResponse, typeof queryKey>({
         enabled: !!(organizationId),
         queryKey,
         queryFn: async ({ signal }) => {
            return listInvitations(organizationId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List invitations
 * {@link /api/organizations/:organizationId/invitations}
 */
export function useListInvitations<TData = ListInvitationsQueryResponse, TQueryData = ListInvitationsQueryResponse, TQueryKey extends QueryKey = ListInvitationsQueryKey>(organizationId: ListInvitationsPathParams["organizationId"] | undefined, params?: ListInvitationsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ListInvitationsQueryResponse, ResponseErrorConfig<ListInvitations400 | ListInvitations401 | ListInvitations403 | ListInvitations404 | ListInvitations409 | ListInvitations500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? listInvitationsQueryKey(organizationId, params)
         

         const query = useQuery({
          ...listInvitationsQueryOptions(organizationId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ListInvitations400 | ListInvitations401 | ListInvitations403 | ListInvitations404 | ListInvitations409 | ListInvitations500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}